<template>
    <div class="ChatCQU_sci">
        <div class="header_top">
            <div data-v-416090d0="" class="header">
                <img data-v-416090d0="" src="../../assets/img/logo.b36a40c1.png" alt="">
                <div data-v-416090d0="" class="headerInfo">
                    <span data-v-416090d0="">
                        <span data-v-416090d0="">
                            <!-- <i data-v-416090d0="" class="el-icon-s-home" style="color:#2C74C9"></i>
                             Access provided by 盈科千信 -->
                        </span>
                    </span>

                </div>
            </div>
        </div>
        <div class="box">
            <div class="main_body">

                <div class="seizeSeat"></div>
                <div class="main_left">
                    <!-- @change="handleChange" -->
                    <el-collapse v-model="activeNames">
                        <!--  v-if="left_body && left_body.length>0" -->
                        <el-collapse-item title="精选结果" name="1" v-if="left_body && left_body.length > 0">
                            <div class="sift_list">
                                <div v-if="sideLoading" class="loading_box" element-loading-spinner="el-icon-loading"
                                    v-loading="sideLoading" element-loading-text="加载中..."></div>
                                <ul v-else>
                                    <li class="select_li"
                                        style="padding:10px 20px;text-align:left;cursor: pointer;display: flex;justify-content: space-between;"
                                        v-for="(item, index) in left_body" :key="index">
                                        <span class="span"
                                            style="display:inline-block;width: 80%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis"
                                            :title="item.value">{{ item.value }}</span>
                                        <i class="el-icon-close" @click="deleteCheck(index)" style="line-height:2"></i>

                                    </li>
                                    <li v-if="left_body && left_body.length > 0"
                                        style="text-align:right;padding:0 8px;color:#0077c2;cursor: pointer;"
                                        @click="clearFilter">清空筛选</li>
                                </ul>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="年份" name="2">
                            <div class="sift_list" v-if="left_data">
                                <div v-if="sideLoading" class="loading_box" element-loading-spinner="el-icon-loading"
                                    v-loading="sideLoading" element-loading-text="加载中..."></div>
                                <ul v-else>

                                    <li class="select_li" @click="leftCheck('year', item.key)"
                                        style="padding:10px 20px;text-align:left;cursor: pointer;"
                                        v-for="(item, index) in left_data.aggs_year" :key="index">
                                        <span class="span"
                                            style="display:inline-block;width: 80%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis"
                                            :title="item.key">{{ item.key }}</span>
                                    </li>
                                    <div class="no_list" v-if="left_data.aggs_year && left_data.aggs_year.length <= 0">暂无数据
                                    </div>
                                </ul>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="学科" name="3">
                            <div class="sift_list" v-if="left_data">
                                <div v-if="sideLoading" class="loading_box" element-loading-spinner="el-icon-loading"
                                    v-loading="sideLoading" element-loading-text="加载中..."></div>
                                <ul v-else>
                                    <li class="select_li" @click="leftCheck('subject', item.key)"
                                        style="padding:10px 20px;text-align:left;cursor: pointer;"
                                        v-for="(item, index) in left_data.aggs_subject" :key="index">
                                        <span class="span"
                                            style="display:inline-block;width: 80%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis"
                                            :title="item.key">{{ item.key }}</span>
                                    </li>
                                    <div class="no_list"
                                        v-if="left_data.aggs_subject && left_data.aggs_subject.length <= 0">暂无数据</div>
                                </ul>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="作者" name="4">
                            <div class="sift_list" v-if="left_data">
                                <div v-if="sideLoading" class="loading_box" element-loading-spinner="el-icon-loading"
                                    v-loading="sideLoading" element-loading-text="加载中..."></div>
                                <ul v-else>
                                    <li class="select_li" @click="leftCheck('author', item.key)"
                                        style="padding:10px 20px;text-align:left;cursor: pointer;"
                                        v-for="(item, index) in left_data.aggs_author" :key="index">
                                        <span class="span"
                                            style="display:inline-block;width: 80%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis"
                                            :title="item.key">{{ item.key }}</span>
                                    </li>
                                    <div class="no_list" v-if="left_data.aggs_author && left_data.aggs_author.length <= 0">
                                        暂无数据</div>
                                </ul>
                            </div>

                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="main_right" v-loading="loading" element-loading-text="加载中..."
                    element-loading-spinner="el-icon-loading">
                    <!-- 搜索区域 -->
                    <div class="top_search">
                        <div class="search_type">
                            <div>
                                <span v-if="showAll || switchType == 1" @click="searchResult('all', 1)"
                                    :class="{ 'active': searchType === 'all' }">搜索全部</span>
                                <span v-if="showAll || switchType == 2" @click="searchResult('result', 2)"
                                    :class="{ 'active': searchType === 'result' }">{{ showAll ? '搜索以下结果' : '传统逻辑检索' }}</span>
                            </div>
                            <!-- </div> -->
                            <div class="switch" @click="switchTypeFun" v-if="!showAll">
                                <img src="@/assets/img/切换 (2).png" width="25px" style="vertical-align: middle;">
                                <span v-if="switchType === 1">切换传统逻辑检索</span>
                                <span v-else>切换语义检索</span>
                            </div>
                        </div>
                        <!-- 搜索全部 -->
                        <div v-if="searchType === 'all' || switchType === 1">
                            <el-input type="textarea" :rows="5" placeholder="请输入需要查询文章的摘要或主题 (篇名、关键词等)..."
                                v-model="textarea" style="" @keydown.native="keydown">
                            </el-input>
                            <div class="fun_row" style="display: flex;">
                                <!-- <div></div> -->
                                <div style="margin: 10px;text-align: right;">
                                    <span style="margin-right:15px;cursor: pointer;" @click="deleteSearch">
                                        <img src="@/assets/img/u361.svg" class="search_icon">
                                        清空搜索
                                    </span>
                                    <img src="@/assets/img/u347.svg" class="search_icon" @click="search">
                                </div>
                            </div>

                        </div>

                        <!-- 搜索以下结果 -->
                        <div class="searchdistrict_Advanced" v-if="searchType === 'result' || switchType === 2">
                            <div class="searchdistrict_Advanced_top" v-if="searchType !== 'all'">
                                <el-select size="small" v-model="advancedoptions" style="min-width: 230px;">
                                    <el-option v-for="item in conditionoptions" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                                <el-input size="small" clearable v-model="advancedinput"
                                    placeholder="请输入检索内容..."></el-input>
                                <div style="min-width:100px;display:flex">
                                    <p @click="advancedadd" style="color: #0077c2; font-size: 24px; cursor: pointer"
                                        class="el-icon-circle-plus"></p>
                                    <!-- @click="advancedaddSearch" -->
                                    <p style="cursor: pointer">
                                        <i class="el-icon-search" style="font-size: 24px; color: #0077c2"
                                            @click="advancedaddSearch"></i>
                                    </p>
                                </div>
                            </div>
                            <div class="searchdistrict_Advanced_box">
                                <div class="searchdistrict_Advanced_bottom" v-for="(item, index) in addition" :key="index">
                                    <div style="display: flex;min-width:230px;width: 230px;margin-right: 20px;">
                                        <div class="spanone">
                                            <el-select size="small" v-model="item.logic">
                                                <el-option v-for="(item, i) in keyList" :key="i" :value="item.value"
                                                    :label="item.label" :disabled="item.disabled"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="spantwo">
                                            <!--  @change="changeKey"  -->
                                            <el-select size="small" v-model="item.key">
                                                <el-option v-for="item in conditionoptions" :key="item.value"
                                                    :label="item.label" :value="item.value"
                                                    :disabled="item.disabled"></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <!-- @keyup.enter.native="search" -->
                                    <el-input size="small" clearable v-model="item.value"
                                        placeholder="请输入检索内容..."></el-input>
                                    <div style="min-width:100px">
                                        <p @click="advanceddelete(index)" class="el-icon-remove"
                                            style="color: #0077c2; font-size: 24px"></p>
                                    </div>

                                </div>
                            </div>

                            <span v-if="showAll && searchType === 'result'"
                                style="margin-top:15px;cursor: pointer;float:right" @click="deleteSearch">
                                <img src="@/assets/img/u361.svg" class="search_icon">
                                清空搜索
                            </span>
                        </div>
                    </div>

                    <div v-if="list_data && list_data.length > 0" class="data_list">
                        <div class="data_txt" v-for="(item, index) in list_data" :key="index">
                            <div class="txt_top">
                                <div class="txt_s">
                                    <h3>{{ item.title }}</h3>
                                    <h3>{{ item.ch_title }}</h3>
                                    <!-- <p>{{ item.index_type }}</p> -->
                                    <p v-if="item.author">
                                        <span style="font-weight: 600; font-size: 15px">作者:
                                        </span>
                                        <span>{{ item.author }}
                                        </span>
                                    </p>
                                    <p v-if="item.keyword">
                                        <span style="font-weight: 600; font-size: 15px">关键词:
                                        </span>
                                        <span>{{ item.keyword }}</span>
                                    </p>
                                    <p>
                                        <span style="margin: 0 0 0 0px" v-if="item.year">
                                            <span style="font-weight: 600; font-size: 15px">
                                                年份: </span>{{ item.year }}</span>
                                        <span style="margin: 0 0 0 30px" v-if="item.issn">
                                            <span style="font-weight: 600; font-size: 15px">ISSN:
                                            </span>{{ item.issn }}</span>
                                        <span style="margin: 0 0 0 30px" v-if="item.doi">
                                            <span style="font-weight: 600; font-size: 15px">DOI:
                                            </span>
                                            <!-- https://doi.org/ -->
                                            <span class="doi_css" @click="doi_url(item.doi)">{{ item.doi }} <i
                                                    class="el-icon-top-right"></i></span>
                                        </span>
                                    </p>
                                </div>
                            </div>

                            <div class="abstract_css" v-if="item.abstract">
                                <span style="font-weight: 600; font-size: 15px">摘要: </span>
                                <span v-if="item.abstract_show">{{ item.abstract }}
                                    <span class="view_all" style="" @click="show_all(index)">收起</span></span>
                                <span v-else>
                                    <span v-if="item.abstract.length < 240">{{
                                        item.abstract
                                    }}</span>
                                    <span v-else>{{ item.abstract.slice(0, 240) }} <span>...</span><span class="view_all"
                                            style="" @click="show_all(index)">全部</span></span>
                                </span>
                            </div>

                            <div class="abstract_css" v-if="item.ch_abstract">
                                <span style="font-weight: 600; font-size: 15px">翻译: </span>
                                <span v-if="item.abstract_show_ch">{{ item.ch_abstract }}
                                    <span class="view_all" style="" @click="show_all_ch(index)">收起</span></span>
                                <span v-else>
                                    <span v-if="item.ch_abstract.length < 180">{{
                                        item.ch_abstract
                                    }}</span>
                                    <span v-else>{{ item.ch_abstract.slice(0, 180) }}
                                        <span>...</span><span class="view_all" style=""
                                            @click="show_all_ch(index)">全部</span></span>
                                </span>
                            </div>
                            <div class="list_bottom">
                                <span class="fraction_"><span v-if="showRelated && item.score > 0"></span> </span>
                                <div class="bottom_fun">
                                    <div v-if="item.link">
                                        <img src="@/assets/img/链接 (4).png">
                                        <a :href="item.link" target="_blank">文章链接</a>
                                    </div>
                                    <div @click="similarLiterature(item.abstract)">
                                        <img src="@/assets/img/相似似 (2).png">
                                        相似文献
                                    </div>
                                </div>
                            </div>
                            <!-- class="source_line" -->
                            <div class="source_line" v-if="item.article_source">
                                获取：
                                <span v-for="(item, index) in item.article_source" :key="index">
                                    <img src="../../assets/img/链接 (4).png" width="20px" style="vertical-align: sub;">
                                    <a v-for="(items, key, indexs) in item" :key="indexs" :href="items" target="_blank">{{ key
                                        == '1'  ? 'CNKI中国基础教育期刊库' : key == '3' ? ' 万方数据知识服务平台' :
                                        '维普期刊数据库' }}</a>
                                </span>

                            </div>
                        </div>
                    </div>
                    <div class="data_list"
                        style="height: 300px;display: flex;align-items: center;justify-content: center;margin-top: 20px;padding: 0 15px;"
                        v-else>
                        <div><img src="../../assets/img/wait.8d7d5bd.png" height="200px"></div>
                        <div style="line-height:35px;marginb-left:15px">
                            <div style="font-size:16px;font-weight:700">ChatResearch:</div>
                            <div style="font-size:14px;">基于语义的深度发现</div>
                            <div style="font-size:14px;">基于语义分析与相似度匹配的学科发现系统，可以实现跨语种高效、智能检索</div>
                        </div>
                    </div>
                    <div class="pag_s" v-if="total > size">
                        <span style="display: inline-block;padding: 37px 0px 0px;">{{ total }} 条</span>
                        <el-pagination style="padding: 30px 0px 0 0" background layout="prev, pager, next"
                            :total="total > 10000 ? 10000 : total" :page-sizes="[10, 20]" :page-size="size"
                            :current-page.sync="page" @current-change="handleCurrentChange"></el-pagination>
                    </div>

                    <div class="back_top" @click="backTop">
                        <img src="@/assets/img/返回顶部 (1).png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { chat_research, sideBarListApi, iplogin } from "@/api/classify";
import store from "@/store";
// import store from "@/store";
export default {
    data() {
        return {
            activeNames: ['1', '2', '3', '4'],
            textarea: "",
            switchType: 1,
            showAll: false,
            page: 1,
            size: 10,
            list_data: [],
            translateList: [], //翻译列表
            beforeList: [], //原列表
            beforeSideBar: [],
            translateSideBar: [],
            total: 0,
            loading: false,
            sideLoading: false,
            citation: "",
            sift_orr: true,
            organ_name: "",
            role_: "",
            searchType: 'all',
            addition: [], //新增的规
            advancedoptions: 'title',
            left_body: [],
            left_data: {
                year: [],
                author: [],
                subject: [],
            },
            keyList: [
                {
                    value: 'and',
                    label: 'AND'
                },
                {
                    value: 'or',
                    label: 'OR'
                },
                {
                    value: 'not',
                    label: 'NOR'
                }
            ],
            conditionoptions: [
                {
                    //高级检索条件options
                    value: "title",
                    label: "标题",
                },
                {
                    value: "author",
                    label: "作者",
                },
                {
                    value: "year",
                    label: "发表年份",
                },
                {
                    value: "subject",
                    label: "学科",
                },
                {
                    value: "abstract",
                    label: "摘要",
                },
                {
                    value: "issn",
                    label: "ISSN 号",
                },
                {
                    value: "keyword",
                    label: "关键词",
                },
            ],
            advancedinput: "", // 高级搜索的input内容
            // radio: false,
            // radioText: 1,
            active: 5,
            showRelated: true,
            value: 'ChatResearch'
        };
    },
    created() {
        if (!store.getCookie("Chat_token")) {
            this.ipLogin()
        } else {
            if (this.$route.query.search) {
                this.textarea = this.$route.query.search
            }
            this.get_data();
            this.getSideBar();
        }
    },
    mounted() {

    },
    methods: {
        ipLogin() {
            this.ip_state = true;
            iplogin()
                .then((res) => {
                    // console.log(res);
                    if (res.data.code == 0) {
                        store.setCookie("Chat_token", res.data.data.token);
                        window.localStorage.setItem("userSpeakId", res.data.data.organ_id)
                        // if (res.data.data.role.length == 1) {
                        //   sessionStorage.setItem("Chat_type", res.data.data.role[0]);
                        // } else {
                        //   sessionStorage.setItem("Chat_type", 3);
                        // }
                        window.localStorage.setItem("accountType", res.data.data.user_type)
                        store.setCookie("organ_name", res.data.data.organ_name)
                        store.setCookie("rolePermissions", this.$encryptData(res.data.data.role))
                        if (res.data.data.logo) {
                            sessionStorage.setItem("logo_img", res.data.data.logo);
                        }
                        if (this.$route.query.search) {
                            this.textarea = this.$route.query.search
                        }
                        this.get_data();
                        this.getSideBar();
                        // this.$router.push({ path: "/home" });
                        // 跳转路由
                        if (res.data.data.role.includes("11")) {
                            // 新知医学页面 直接跳转
                            this.$router.push({
                                path: "/knowledgeResearch",
                                query: {
                                    search: this.searchInfo
                                }
                            });
                        }
                    }
                    this.ip_state = false;
                })
                .catch((err) => {
                    this.ip_state = false;
                    console.log(err); //直接捕获 new Promise  reject("rejected status")
                });
        },
        keydown(event) {
            if (event.key === 'Enter') {
                if (event.ctrlKey) {
                    // 用户按下了 Ctrl + Enter 组合键
                    this.textarea += '\n'
                } else {
                    // 用户按下了单独的 Enter 键
                    event.preventDefault()
                    this.search()
                }
            }
        },
        leftCheck(type, key) {
            // 判断left_body是否存在key == type的数据，存在则return，不存在则push
            let index = this.left_body.findIndex(item => item.key == type)
            if (index == -1) {
                this.left_body.push({
                    key: type,
                    logic: 'and',
                    value: key
                })
            } else {
                return
            }
            this.page = 1
            this.get_data()
            this.getSideBar()
            // 回到顶部
            this.backTop()
        },

        search_img(txt) {
            this.textarea = txt;
            this.search();
        },
        changeLogic(val) {
            let yearArr = []
            let issArr = []
            // 切换and or nor
            if (this.advancedoptions === 'year') {
                yearArr.push({ logic: 'and', key: 'year' })
            }
            if (this.advancedoptions === 'issn') {
                issArr.push({ logic: 'and', key: 'issn' })
            }
            if (this.left_body.length > 0) {
                this.left_body.forEach(item => {
                    if (item.key === 'year') {
                        yearArr.push(item)
                    }
                    if (item.key === 'issn') {
                        issArr.push(item)
                    }
                })
            }
            if (this.addition.length > 0) {
                this.addition.forEach(item => {
                    if (item.key === 'year') {
                        yearArr.push(item)
                    }
                    if (item.key === 'issn') {
                        issArr.push(item)
                    }
                })
            }
            // 如果包含key==‘year’的字段
            if (val === 'and' || val === 'not') {
                if (yearArr.length > 0 && issArr.length == 0) {
                    this.conditionoptions[2].disabled = true
                    this.conditionoptions[5].disabled = false
                } else if (yearArr.length == 0 && issArr.length > 0) {
                    this.conditionoptions[5].disabled = true
                    this.conditionoptions[2].disabled = false
                } else if (yearArr.length > 0 && issArr.length > 0) {
                    this.conditionoptions[2].disabled = true
                    this.conditionoptions[5].disabled = true
                } else {
                    this.conditionoptions[2].disabled = false
                    this.conditionoptions[5].disabled = false
                }
            }
        },
        changeKey(val) {
            let yearArr = []
            let issArr = []
            // 切换and or nor
            if (this.advancedoptions === 'year') {
                yearArr.push({ logic: 'and', key: 'year' })
            }
            if (this.advancedoptions === 'issn') {
                issArr.push({ logic: 'and', key: 'issn' })
            }
            if (this.left_body.length > 0) {
                this.left_body.forEach(item => {
                    if (item.key === 'year') {
                        yearArr.push(item)
                    }
                    if (item.key === 'issn') {
                        issArr.push(item)
                    }
                })
            }
            if (this.addition.length > 0) {
                this.addition.forEach(item => {
                    if (item.key === 'year') {
                        yearArr.push(item)
                    }
                    if (item.key === 'issn') {
                        issArr.push(item)
                    }
                })
            }
            // 如果包含key==‘year’的字段
            if (val === 'year' || val === 'issn') {
                if (yearArr.length > 0 || issArr.length > 0) {
                    this.keyList = [
                        {
                            value: 'or',
                            label: 'OR'
                        },
                    ]
                } else {
                    this.keyList = [
                        {
                            value: 'and',
                            label: 'AND'
                        },
                        {
                            value: 'or',
                            label: 'OR'
                        },
                        {
                            value: 'not',
                            label: 'NOR'
                        }
                    ]
                }
            }
        },
        // 高度
        clientHight() {
            const box = document.querySelector('.searchdistrict_Advanced_box')
            const height = box.scrollHeight + 42
            if (height >= 84) {
                box.scrollTop = height
            }
        },
        // 添加搜索规则
        advancedadd() {
            if (!this.advancedinput) {
                console.log('1', document.getElementsByClassName("el-message").length < 1);
                if (document.getElementsByClassName("el-message").length < 1) {
                    this.$message({
                        message: this.$t("chatresearch.inputTips"),
                        time: 800,
                        type: "warning",
                        offset: '60'
                    });
                    return
                }

            } else if (this.addition.length > 0) {
                if (this.addition[this.addition.length - 1].value == "") {
                    this.$message.warning(this.$t("chatresearch.inputTips"));
                    return;
                } else {
                    this.addition.push({
                        logic: "and",
                        key: "title",
                        value: "",
                    });
                    this.$nextTick(() => {
                        this.clientHight()
                    })
                }
                console.log('2');
            } else {
                this.addition.push({
                    logic: "and",
                    key: "title",
                    value: "",
                });
                this.$nextTick(() => {
                    this.clientHight()
                })
                console.log(this.addition);
            }

        },
        // 删除规则
        advanceddelete(i) {
            this.addition.splice(i, 1);
            // this.search();
        },
        changeRadio(val) {
            // 切换语言单选框 val为true 
            // 存为false时的页码befor_Page
            // 取translate_Page， 
            // 无值页码置为1
            if (val === true) {
                sessionStorage.setItem('befor_Page', this.page)
                if (sessionStorage.getItem('translate_Page')) {
                    this.page = +sessionStorage.getItem('translate_Page')
                } else {
                    this.page = 1
                }
            } else {
                sessionStorage.setItem('translate_Page', this.page)
                if (sessionStorage.getItem('befor_Page')) {
                    this.page = +sessionStorage.getItem('befor_Page')
                } else {
                    this.page = 1
                }
            }
            if (this.radio === false) {
                this.list_data = this.beforeList
                this.total = this.beforeTotal
                this.left_data = this.beforeSideBar
            } else {
                this.list_data = this.translateList
                this.total = this.translateTotal
                this.left_data = this.translateSideBar
            }
        },

        // 检索
        search() {
            this.page = 1
            this.showAll = true
            // 将列表页面置为1
            sessionStorage.setItem('translate_Page', 1)
            sessionStorage.setItem('befor_Page', 1)
            this.get_data()
            this.getSideBar()
            // if(this.searchType === 'all'){
            //     this.showRelated = true
            // }else{
            //     this.showRelated = false
            // }
            // 回到顶部
            this.backTop()
        },
        // 删除精选结果
        deleteCheck(i) {
            this.left_body.splice(i, 1)
            this.get_data()
            this.getSideBar()
            // 回到顶部
            this.backTop()
        },
        // 普通检索
        get_data() {
            this.loading = true;
            // let cqu_copy = { ...this.cqu };
            var form = {};
            form.text = this.textarea
            form.page = this.page
            form.size = this.size
            form.xz = true
            // 如果textarea框中存在检索此条 进行tr赋值
            // if(this.textarea){
            //     if(e === false || e === true){
            //         form.tr = e
            //     }else{
            //         form.tr = this.radio
            //     }
            // }
            let base
            let dataAllList
            if (this.advancedinput !== '') {
                base = [
                    {
                        key: this.advancedoptions,
                        logic: 'and',
                        value: this.advancedinput
                    }
                ]
                // key为year及issn时  logic为 or
                // this.addition.forEach(item => {
                //     if(item.key === 'year' || item.key === 'issn'){
                //         item.logic = 'or'
                //     }
                // })
                dataAllList = base.concat(this.addition)
            } else {
                dataAllList = []
            }
            form.search_body = dataAllList.concat(this.left_body)
            chat_research(form).then(res => {
                if (res.data.code === 1) {
                    this.$message.error(res.data.msg)
                    this.loading = false;
                } else {
                    res.data.data.forEach((item) => {
                        item.abstract_show = false;
                        item.abstract_show_ch = false;
                    });
                    console.log(res);
                    this.list_data = res.data.data
                    this.total = res.data.total
                    this.loading = false;
                }

            })
        },

        getSideBar() {
            this.sideLoading = true;
            // let cqu_copy = { ...this.cqu };
            var form = {};
            form.text = this.textarea
            form.page = this.page
            form.size = this.size
            form.xz = true
            let base
            let dataAllList
            if (this.advancedinput !== '') {
                base = [
                    {
                        key: this.advancedoptions,
                        logic: 'and',
                        value: this.advancedinput
                    }
                ]
                dataAllList = base.concat(this.addition)
            } else {
                dataAllList = []
            }
            form.search_body = dataAllList.concat(this.left_body)
            sideBarListApi(form).then(res => {
                if (res.data.code === 1) {
                    this.$message.error(res.data.msg)
                    this.sideLoading = false;
                } else {
                    this.left_data = res.data.data
                    this.sideLoading = false;

                }
            })
        },
        // 高级检索 搜索以下结果
        advancedaddSearch() {
            //    判断默认搜索框是否为空
            if (this.advancedinput === '') {
                this.$message.warning(this.$t("chatresearch.inputTips"));
                return
            } else if (this.addition.length > 0 && this.addition[this.addition.length - 1].value === '') {
                this.$message.warning(this.$t("chatresearch.inputTips"));
                return
            } else {
                this.page = 1
                if (this.showAll === true || this.searchType == 'all') {
                    // 相关度展示 在语义检索的情况下展示
                    this.showRelated = true
                    // 语义检索基础上逻辑检索
                    this.get_data()
                    this.getSideBar()
                } else {
                    // 传统逻辑检索
                    this.showRelated = false
                    this.textarea = ''
                    this.get_data()
                    this.getSideBar()
                }
                // 回到顶部
                this.backTop()
            }

        },
        // 切换至搜索以下结果
        searchResult(t, num) {
            this.searchType = t
            this.switchType = num
            // 计算下方列表最大高度
        },
        // 检索相似文献
        similarLiterature(text) {
            this.left_body = []
            this.advancedinput = ''
            this.addition = []
            this.searchType = 'all'
            this.textarea = text
            // 检索
            this.search()
        },
        switchTypeFun() {
            this.textarea = ''
            this.page = 1
            this.advancedinput = ''
            this.addition = []
            this.left_body = []
            if (this.switchType === 1) {
                // 语义检索
                this.searchType = 'result'
                this.switchType = 2
            } else {
                // 传统逻辑检索
                this.searchType = 'all'
                this.switchType = 1
            }
            this.get_data()
            this.getSideBar()
            this.showAll = false
        },
        // 清空搜索条件
        deleteSearch() {
            // 如果是语义检索 下的清空 则清空语义检索及检索以下结果中的所有条件
            if (this.showAll == true && this.searchType === 'all') {
                this.textarea = ''
                this.addition = []
                this.advancedinput = ''
                this.left_body = []
                this.get_data()
                this.getSideBar()
                this.showAll = false
                this.switchType = 1
                this.searchType = 'all'
            } else {
                console.log('11');
                this.addition = []
                this.advancedinput = ''
                this.searchType = 'all'
                this.get_data()
                this.getSideBar()
            }
        },
        // 清空左侧聚合筛选
        clearFilter() {
            // 如果是雨衣搜索 调用两次接口
            // 如果是传统逻辑检索 调用一次
            this.left_body = []
            this.get_data()
            this.getSideBar()
            // 回到顶部
            this.backTop()
        },

        // 下方列表滚动到顶部操作
        backTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
        // 英文摘要展示全部
        show_all(i) {
            this.list_data[i].abstract_show =
                !this.list_data[i].abstract_show;
        },
        // 中文摘要展示全部
        show_all_ch(i) {
            this.list_data[i].abstract_show_ch =
                !this.list_data[i].abstract_show_ch;
        },
        // 分页切换 区分原搜索及切花语言搜索（中英文切换）
        handleCurrentChange(val) {
            this.page = val;
            this.get_data();
        },

        doi_url(url) {
            window.open("https://doi.org/" + url, "_blank");
        },
    },
};
</script>
  
<style lang='less' scoped>
/deep/ .customClass {
    z-index: 2005 !important;
}

.customClass {
    z-index: 2002 !important;
}

.header_top {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2001;
    background: #ffffff;

    // 
    .header {
        height: 70px;
        display: flex;
        align-items: center;
        font-family: Times New Roman;
        padding: 10px 20px;
        position: relative;

        .headerInfo {
            margin-left: auto;
        }
    }
}

.ChatCQU_sci {
    min-height: 100vh;
    position: relative;
    background: #F1F2F6;

    // padding: 20px 0;
    // background: url("../../assets/img/背景图/小助手-05(1).jpg") repeat;
    background-size: 100% 100%;
    background-position: center center;
    overflow-x: hidden;
}

/deep/ .el-textarea__inner {
    max-height: 112px;
}

.ChatCQU_sci {
    // padding: 20px 0 0 0 ;
    // // width: 100%; height: 100vh;
    // background: url("../../assets/img/背景图/小助手-05(1).jpg")  no-repeat;
    // background-size: 100% 100%;
    // background-attachment: fixed;
}

@media screen and (max-width: 1000px) {
    // .main_left{

}

.box {
    margin: auto;
    width: 80%;
    max-width: 1500px;
    min-width: 1150px;
    padding: 20px 0;
    margin-top: 70px;


    .chat_s {
        // text-align: center;
        // text-align: left;
        // line-height: 50px;
        // position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        // flex-shrink: 0;
        margin: 0 0 20px 0;

        .skip_host {
            display: inline-block;
            padding: 10px 30px 10px 30px;
            color: #444547;
            font-weight: 600;
            font-size: 20px;
        }

        .skip_sub {
            display: inline-block;
            //   width: 180px;
            padding: 10px 30px 10px 30px;
            font-size: 15px;
            font-weight: 500;
            letter-spacing: 0px;
            color: #909399;
            // line-height: 20px;
        }

        .skip_sub:hover {
            cursor: pointer;
            color: #444547;
            font-weight: 600;
        }
    }
}

.main_body {
    // padding: 20px;
    // margin: 20px;
    display: flex;
    justify-content: space-between;


    // height: calc(100vh - 150px);
    // height: 420px;
    .main_left::-webkit-scrollbar {
        display: none;
    }

    .seizeSeat {
        width: 22%
    }

    .main_left {
        position: fixed;
        left: 8%;
        top: 90px;
        bottom: 20px;
        width: 17.6%;
        // margin: 0 10px 0 0;
        background: white;
        border-radius: 10px;
        padding: 10px;
        height: calc(100vh - 110px);
        // min-height:100vh;
        overflow-x: hidden;
        overflow-y: scroll;
        margin-bottom: 20px;
        min-width: 252px;

        .loading_box {
            width: 100%;
            height: 200px;
        }

        .sift_list {
            max-height: 200px;
            // min-height: 200px;
            // max-height: 240px;
            position: relative;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            border-end-start-radius: 10px;
            border-end-end-radius: 10px;

            .select_li {
                padding: 10px 20px;
                text-align: left;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 100%;

                .span {
                    display: inline-block;
                    width: 90%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis
                }
            }

            .el-checkbox {
                display: flex;
                align-content: center;
                margin: 10px;

                /deep/ .el-checkbox__input {
                    white-space: nowrap;
                    cursor: pointer;
                    outline: none;
                    display: inline-block;
                    line-height: 1;
                    position: relative;
                    vertical-align: middle;
                }

                /deep/ .el-checkbox__inner {
                    display: inline-block;
                    position: relative;
                    top: 2px;
                }

                /deep/ .el-checkbox__original {
                    opacity: 0;
                    outline: 0;
                    position: absolute !important;
                    margin: 0;
                    width: 0 !important;
                    height: 0 !important;
                    z-index: -1;
                }

                /deep/ .el-checkbox__label {
                    white-space: nowrap; //文本强制不换行；
                    text-overflow: ellipsis; //文本溢出显示省略号；
                    overflow: hidden; //溢出的部分隐藏；
                }
            }
        }

        .no_list {
            height: 30px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 15px 0;
        }

        .sift_list::-webkit-scrollbar {
            // display: none;
            width: 5px;
        }

        .sift_list::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
            background: rgba(0, 0, 0, 0);
        }

        .sift_list::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
            border-radius: 0;
            background: rgba(190, 235, 231, 0);
        }

        .sift_list:hover::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: rgba(0, 0, 0, 0.2);
        }

        .sift_list:hover::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            border-radius: 0;
            background: rgba(190, 235, 231, 0.1);
        }

        /deep/ .el-collapse {
            border: none;
        }

        /deep/ .el-collapse-item {
            margin-bottom: 20px;
        }

        /deep/ .el-collapse-item__wrap {
            border: none;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04)
        }

        /deep/ .el-collapse-item__header {
            background-color: #B3B4B5;
            font-weight: 600;
            color: #ffffff;
            padding-left: 10px;
            font-size: 14px;
            height: 40px;
            border-start-start-radius: 3px;
            border-start-end-radius: 3px;
        }

        /deep/ .el-collapse-item__content {
            padding-bottom: 0px;
        }
    }

    @media screen and (max-width: 1425px) {
        .main_left {
            left: 6%;
        }
    }

    @media screen and (max-width: 1380px) {
        .main_left {
            left: 5%;
        }
    }

    @media screen and (max-width: 1320px) {
        .main_left {
            left: 4%;
        }
    }

    @media screen and (max-width: 1260px) {
        .main_left {
            left: 2%;
        }
    }

    @media screen and (max-width: 1220px) {
        .main_left {
            left: 2%;
        }
    }

    @media screen and (max-width: 1200px) {
        .main_left {
            left: 1%;
        }
    }

    .main_right {
        // margin-left:24%;
        width: 76%;
        // margin: 0 0px 0 10px;
        background: white;
        border-radius: 10px;
        padding: 15px 0;
    }
}

.main_left {
    h2 {
        text-align: left;
        line-height: 35px;
        color: #444547;
        font-weight: 800;
        font-size: 16px;
        letter-spacing: 1px;
    }
}


.main_right {
    text-align: left;
    position: relative;

    .top_search {
        box-shadow: 0px 0px 5px rgba(170, 170, 170, 0.34901960784313724);
        padding: 10px;
        margin: 0 15px;
        margin-bottom: 10px;
        box-sizing: border-box;

        .fun_row {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            /deep/ .el-radio__input.is-checked .el-radio__inner {
                border-color: #e6a23c;
                background: #e6a23c;
            }

            /deep/ .el-radio__input.is-checked+.el-radio__label {
                color: #e6a23c;
            }
        }

        .search_type {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            align-items: center;

            .switch {
                color: #0077c2;

                img {
                    margin-right: 5px;
                    vertical-align: middle;
                    height: 20px !important;
                }

                span {
                    margin: 0;
                }
            }

            span {
                margin: 15px;
                padding-bottom: 5px;
                cursor: pointer;
            }

            .active {
                border-bottom: 2px solid #0077c2;
                color: #0077c2;
                font-weight: 600;
            }
        }

        .searchdistrict_Advanced {
            max-height: 158px;
            overflow-y: scroll;

            .searchdistrict_Advanced_top {
                display: flex;
                justify-items: center;
                align-items: center;

                .el-select {
                    //   width: 18%;
                    width: 230px;
                    margin-right: 20px;
                }

                .el-input {
                    width: 65%;
                    margin: 0 20px 0 0;
                }

                p {
                    display: flex;
                    justify-items: center;
                    align-items: center;
                    margin-right: 20px;
                }
            }

            .searchdistrict_Advanced_box {
                max-height: 84px;
                overflow: auto;
            }

            .searchdistrict_Advanced_box::-webkit-scrollbar {
                display: none;
            }

            .searchdistrict_Advanced_bottom {
                margin-top: 10px;
                display: flex;

                // justify-items: center;
                // align-items: center;
                .spanone {
                    //   width: 7%;
                    width: 47%;
                }

                .spantwo {
                    width: 47%;
                }

                .spantwo {
                    margin-left: 20px;
                }

                .el-input {
                    width: 65%;
                    margin-right: 20px;
                }
            }
        }
    }

    .search_icon {
        vertical-align: middle;
        height: 20px;
        cursor: pointer;
    }

    .searchdistrict_Advanced::-webkit-scrollbar {
        display: none;
    }

    .data_list::-webkit-scrollbar {
        display: none;
    }

    .data_list {
        min-height: calc(100vh - 360px);
        overflow-x: hidden;
        overflow-y: scroll;

        .data_txt {
            margin: 0 0 10px 0;

            box-shadow: 0px 0px 5px rgba(170, 170, 170, 0.34901960784313724);
            border-radius: 5px;
            padding: 10px;
            margin: 5px 15px;

            .txt_top {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .txt_s {
                    width: calc(100% - 120px);

                    h3 {
                        font-size: 16px;
                        letter-spacing: 1px;
                        line-height: 22px;
                        margin: 0 0 5px 0;
                        color: #000000;
                        font-weight: 600;
                    }

                    p {
                        line-height: 20px;
                        margin: 0 0 10px 0;
                        color: #5a5a5a;
                    }
                }

                .img_s {
                    width: 95px;
                    cursor: pointer;

                    img {
                        // width: 80px;
                        width: 55px;
                        margin: 0 20px;
                    }
                }
            }

            .abstract_css {
                line-height: 25px;
            }
        }
    }

    .pag_s::-webkit-scrollbar {
        display: none;
    }

    .pag_s {
        display: flex;
        justify-content: center;
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;

        /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
            // background-color: #e6a23c;
        }

        // /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover{
        //     color: #606266;
        // }
        // /deep/ .el-pagination.is-background .el-pager li{
        //     color:  #606266;
        // }
    }

    .back_top {
        position: absolute;
        bottom: 20px;
        right: -60px;
    }
}

.view_all {
    margin: 0 0 0 10px;
    font-size: 15px !important;
    font-weight: 600;
    cursor: pointer;
}

.view_all:hover {
    color: #0077c2;
}

.img_txt {
    color: #a21e1e;
    font-size: 15px;
    // letter-spacing: 5px;
    font-weight: 600;
    text-align: center;
    line-height: 25px;
}

.list_bottom {

    // margin: 10px 0;
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    cursor: pointer;

    .bottom_fun {
        min-width: 440px;
        display: flex;
        justify-content: flex-end;

        div {
            margin: 0 8px;
        }

        img {
            vertical-align: middle;
            width: 22px;
            margin-right: 3px;
        }
    }
}

.source_line {
    font-size: 15px;
    margin: 10px 0;

    span {
        border: 1px solid #ccc;
        padding: 5px 10px;
        border-radius: 20px;
        margin-right: 15px;

        a {
            font-size: 14px !important;
        }
    }
}

.fraction_ {
    display: inline-block;
    color: #8b1a1a;
    font-weight: 600;
    font-size: 20px;
}

.doi_css {
    color: #007398;
    border-bottom: 1px solid #ffffff;
    cursor: pointer;
}

.doi_css:hover {
    color: #409eff;
    border-bottom: 1px solid #409eff;
}</style>